// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"a6c8331c","92":"fb9ffa6e","125":"8b38d606","129":"91f561ee","345":"edf03a0c","628":"669f9c7f","672":"2edb77cd"}[chunkId] + ".chunk.js";
};